// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"Slider-module--sliderWrapper--QgNXd","slider":"Slider-module--slider--Attvj","disabled":"Slider-module--disabled--3_86r"};